'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var AnchorList = require('bunsen/models/AnchorList');
var endpoints = require('dibs-endpoints');
var assert = require('bunsen/helpers/assert');
var _ = require('underscore');
var constants = {
    listTypes: {
        SELLER_POLICY: 'SELLER_POLICY',
        SELLER_WHITELIST: 'SELLER_WHITELIST'
    },

    listNames: {
        PRE_AUG_2015: 'PRE_AUG_2015',
        OPOP: 'OPOP',
        LISTING_CREDIT_WHITELIST: 'LISTING_CREDIT_WHITELIST'
    },

    listDisplayNames : {
        PRE_AUG_2015: 'Original 1stdibs policy',
        OPOP: 'OPOP'
    }
};

module.exports = SoaCollection.extend({
    url: endpoints.anchorLists,
    model: AnchorList,

    /**
     * Fetches anchor list models for a given seller, list type and name. For example, use this method to search for
     * anchor lists that associate sellers to policies.
     * @param sellerId - ID of seller you are searching for.
         * @param listName - the name of the list searched for. eg. SELLER_POLICY list has "PRE_AUG_2015"
     * @param listType - constant value for the fetched list type. eg. SELLER_POLICY
     * @returns {*}
     */
    fetchSellerOnList: function (sellerId, listName, listType) {
        assert(listType, 'list type is required to use this method');
        assert(listName, 'list name is required to use this method');
        return this._drySellerFetch(sellerId, listType, listName);
    },

    /**
     * Fetch anchor list models for a given seller to dealer policies. Fetches all anchor lists between a seller any
     * seller policies that seller is anchored to. Useful for figuring out which seller policy a seller has.
     * @param sellerId - <string> seller ID
     * @param fetchOptions - BB options to be passed to fetch() method.
     * @returns {*}
     */
    fetchListForSellerPolicy : function (sellerId, fetchOptions) {
        return this._drySellerFetch(sellerId, constants.listTypes.SELLER_POLICY, null, fetchOptions);
    },

    _drySellerFetch : function (sellerId, listType, listName, fetchOptions) {
        assert(sellerId, 'seller ID is required to use this method');
        var data = { anchors: 'SELLER-' + sellerId };
        if (listType) {
            data.listTypes = listType;
        }
        if (listName) {
            data.listNames = listName;
        }
        return this.fetch(_.extend(fetchOptions || {}, { data: data }));
    },

    /**
     * Gets an array of all the policy names contained in this anchor list ... list. Pass getDisplayNames as true if
     * you want the display name instad of the list name code.
     * @param getDisplayNames - <bool> - true if you want display names, else code will be returned.
     * @returns {*}
     */
    getPolicyNames : function (getDisplayNames) {
        return this.where({type : constants.listTypes.SELLER_POLICY}).map(function (model) {
            var name = model.get('name');
            return getDisplayNames ? constants.listDisplayNames[name] : name;
        });
    },

    /**
     * Gets an array of list names contained in specified anchor list type
     * @param {String} listType
     */
    getListNames: function (listType) {
        return this.where({type : listType}).map(function (model) {
            return model.get('name');
        });
    }

}, constants);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/AnchorLists.js
// module id = 117
// module chunks = 62